import * as React from "react"
import { cn } from "../../lib/utils"

const Dialog = ({ open, onOpenChange, children, ...props }) => {
  if (!open) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <div 
        className="fixed inset-0 bg-black/50" 
        onClick={() => onOpenChange?.(false)}
        style={{
          top: 'env(safe-area-inset-top)',
          bottom: 'env(safe-area-inset-bottom)',
          left: 'env(safe-area-inset-left)',
          right: 'env(safe-area-inset-right)',
        }}
      />
      <div className="relative z-50 w-full max-w-lg mx-4" {...props}>
        {children}
      </div>
    </div>
  );
};

const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => {
  // 如果 className 包含 flex 或 p-0，则不添加默认的 overflow-y-auto
  const hasCustomLayout = className?.includes('flex') || className?.includes('p-0');
  
  return (
    <div
      ref={ref}
      className={cn(
        "relative bg-background rounded-lg shadow-lg w-full",
        // iOS Safari 优化：使用 calc 计算最大高度，考虑安全区域
        "max-h-[calc(90vh-env(safe-area-inset-top)-env(safe-area-inset-bottom))]",
        !hasCustomLayout && "p-4 sm:p-6 overflow-y-auto",
        className
      )}
      style={{
        // iOS Safari 滚动优化
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
      }}
      {...props}
    >
      {children}
    </div>
  );
})
DialogContent.displayName = "DialogContent"

const DialogHeader = ({ className, ...props }) => (
  <div
    className={cn("flex flex-col space-y-1.5 text-center sm:text-left mb-4", className)}
    {...props}
  />
)
DialogHeader.displayName = "DialogHeader"

const DialogTitle = React.forwardRef(({ className, children, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn("text-lg font-semibold leading-none tracking-tight", className)}
    {...props}
  >
    {children}
  </h2>
))
DialogTitle.displayName = "DialogTitle"

const DialogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
))
DialogDescription.displayName = "DialogDescription"

const DialogFooter = ({ className, ...props }) => (
  <div
    className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-6", className)}
    {...props}
  />
)
DialogFooter.displayName = "DialogFooter"

export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter }

